import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import HomeIcon from './HomeIcon';
import s from './HomeDialog.module.css';
// Native modal dialogs provide focus containment, background inertness and top-layer stacking.
export default function HomeDialog({title,subtitle,onClose,children,wide=false,header,className='',ariaLabel}) {
 const ref=useRef(null), closeRef=useRef(onClose), down=useRef(false);
 closeRef.current=onClose;
 useEffect(()=>{
  const dialog=ref.current, previous=document.activeElement;
  dialog.showModal();
  return ()=>{dialog.close(); if(previous?.isConnected) previous.focus();};
 },[]);
 return createPortal(<dialog ref={ref} className={`${s.dialog} ${wide?s.wide:''} ${className}`} aria-label={ariaLabel||title}
  onKeyDown={e=>{e.stopPropagation();if((e.ctrlKey||e.metaKey)&&e.key.toLowerCase()==='k')e.preventDefault();}}
  onCancel={e=>{e.preventDefault();e.stopPropagation();closeRef.current();}}
  onPointerDown={e=>{down.current=e.target===e.currentTarget;}}
  onPointerUp={e=>{if(down.current&&e.target===e.currentTarget)closeRef.current();down.current=false;}}>
  {header!==undefined?header:<header className={s.header}><div><h2>{title}</h2>{subtitle&&<p>{subtitle}</p>}</div><button type="button" onClick={onClose} aria-label={`Close ${title}`}><HomeIcon name="close"/></button></header>}
  {children}
 </dialog>,document.body);
}
